module.exports = __webpack_public_path__ + "static/cockatrice-d52d1e2ee2fe1c8f5d62e7c9416580b0.jpg";